import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {ModelHealthGiveAccessRequestDto} from '../../dtos/modelHealthGiveAccessRequest.dto';

@Injectable({
    providedIn: 'root'
})
export class ModelHealthAdminService {

    constructor(private _httpClient: HttpClient) {}

    public giveAccess(giveAccessDto: ModelHealthGiveAccessRequestDto): Observable<void> {
        return this._httpClient.post<any>(environment.apiUrl + 'api/integration/modelhealth/admin/v1/giveAccess', giveAccessDto);
    }
}
